
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, MapPin } from "lucide-react";
import { companyItems } from "../navData";

const MobileCompanySection = ({ onClose }: { onClose: () => void }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between py-3 border-b w-full text-left"
      >
        <div className="flex items-center">
          <MapPin className="h-5 w-5 text-grandpal-green mr-3" />
          <h3 className="font-medium text-gray-800 font-lora">Company</h3>
        </div>
        <ChevronDown 
          className={`h-5 w-5 text-grandpal-green transition-transform duration-200 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        />
      </button>
      {isOpen && (
        <div className="py-4 pl-4 space-y-3 animate-fade-in">
          {companyItems.map((item) => (
            <div key={item.title} className="flex items-start py-2">
              <div className="mr-3 mt-0.5 bg-grandpal-green-light p-2 rounded-md text-grandpal-green">
                {item.icon}
              </div>
              <div>
                <Link
                  to={item.path}
                  className="block font-medium text-gray-700 hover:text-grandpal-green transition-colors"
                  onClick={onClose}
                >
                  {item.title}
                </Link>
                <p className="text-sm text-grandpal-gray mt-1">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MobileCompanySection;
